export interface HaygentSession {
  session_id: string;
  name: string;
  created_at: string;
}

export interface HaygentMessage {
  role: 'user' | 'assistant';
  content: string;
}

export interface HaygentStreamChunk {
  content: string;
  done: boolean;
  title?: string;
}

export enum HaygentChatState {
  Collapsed = 'collapsed',
  Docked = 'docked',
  Maximized = 'maximized',
}
